import * as Constants from './appTypes';

const initialState = {
  showLoginModal: false,
  anonymousUser: false,
  currentSurvey: null,
  loading: false
};

function appReducer(state, action) {
  switch (action.type) {
    case Constants.SHOW_LOGIN_MODAL:
      return {
        ...state,
        showLoginModal: true
      };

    case Constants.HIDE_LOGIN_MODAL:
      return {
        ...state,
        showLoginModal: false
      };

    case Constants.SET_CURRENT_SURVEY:
      return {
        ...state,
        currentSurvey: action.payload.survey
      };

    case Constants.SET_ANONYMOUS_USER:
      return {
        ...state,
        anonymousUser: true
      };
    case Constants.SET_LOADING:
      return {
        ...state,
        loading: action.payload.loading
      };
    default:
      return state || initialState;
  }
}

export default appReducer;
